export const API_URL = 'https://dispatch.altermedic-center.com/api';

export const getAuthHeader = (token: string | null) => {
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };
}; 